<template>
  <div id="about__infantil" class="fade-in-up">
    <div id="header">
      <div class="img__header">
        <div class="bg__escuro"></div>
        <div class="bg__title">
          <b-container fluid="lg">
            <h2 class="text-title">Educação Infantil</h2>
          </b-container>
        </div>
      </div>
    </div>
    <BreadSistema class="bread__about" />

    <b-container fluid="lg">
      <div class="clearfix">
        <div class="float-right box-image">
          <div class="text-center">
            <img src="../../assets/images/image-pages/educacao-infantil-sistema-cpv.png" alt="">
          </div>
        </div>
        <div class="float-left box-text text-left">
          <div class="content-text">
            <h5 class="text-uppercase font-weight-bolder">Proposta Pedagógica</h5>
            <p class="font-weight-light lead">A criança é a peça central no processo de aprendizagem.</p>
            <p>Por meio de experimentações e vivências, ela vai descobrindo a realidade em que está inserida. Conforme
              interage
              com o mundo em que vive, seu conhecimento é construído, em progresso contínuo, interligado e qualitativo,
              não se restringindo à
              aquisição de informações. Durante esse processo, o papel do professor é conduzir os alunos à reflexão,
              promovendo atividades que estimulem a criatividade,
              a curiosidade, a apreensão de conceitos e a elaboração de suas ideias a respeito do mundo.
            </p>
            <h5 class="text-uppercase font-weight-bolder mt-4">Material didático</h5>
            <p>Os módulos, especialmente elaborados para crianças entre 2 e 5 anos de idade, proporcionam sua imersão
              significativa e prazerosa no mundo do conhecimento. As atividades propostas desenvolvem as linguagens
              oral, corporal, musical,
              artística, escrita, matemática e científica, sempre de acordo com a fase de desenvolvimento da criança e
              com o uso social do aprendizado.
            </p>
            <hr>
            <div class="d-block mx-auto">
              <h5 class="text-center font-weight-bolder text-uppercase">Para mais informações</h5>
              <p class="text text-center">
                Para mais informações sobre esse material, solicite hoje um consultor do Sistema de Ensino CPV.
              </p>
              <div class="d-flex justify-content-center">
                <b-button class="btn__consultor" :to="{ name: 'escolaParceira' }" variant="transparent">
                  <i class="fa-regular fa-messages"></i>
                  <span>Fale com um consultor</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ensino-infantil',
  components: { BreadSistema: () => import('../GlobalComponents/bread-sistema.vue') },
};
</script>

<style lang="scss" scoped>
#about__infantil {
  background-color: #ffffff;

  #header {
    .img__header {
      position: absolute;
      display: block;
      background-image: url('https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2019/10/11135008/bg_educacao-infantil_comprimida.jpg');
      background-repeat: no-repeat;
      background-position: center center;

    }
  }

  h5 {
    color: #e98b24;
  }

  p {
    font-size: 16px;
    line-height: 22px;
  }

  .lead {
    font-size: 24px;
    line-height: 32px;
  }

  .btn__consultor {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 0px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 14px;
    line-height: 20px;

    color: #fdf3e9;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
        font-size: 14px;
        line-height: 20px;
      }
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
    }
  }
}

@media screen and (min-width: 1200px) {
  .box-image {
    width: 35%;
    margin-top: 0px;

    img {
      display: block;
      margin-top: 10px;
      margin-left: auto;
      margin-right: auto;
      height: auto;
      object-fit: cover;

    }
  }

  .box-text {
    width: 65%;
    display: block;
    margin: 30px auto;

    .content-text {
      padding-left: 32px;
      padding-right: 32px;
    }
  }
}

/* @media screen and (min-width: 1200px) and (max-width: 1280px) {
  .box-image {
    width: 50%;
    max-height: 1001px;
    // margin-bottom: 30px;

    img {
      display: block;
      margin-top: 338px;
      margin-left: auto;
      margin-right: auto;
      height: auto;
      object-fit: cover;
    }
  }

  .box-text {
    margin: 30px auto;
    width: 50%;

    display: block;

    .content-text {
      padding-left: 32px;
      padding-right: 32px;
    }
  }
} */
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .box-image {
    width: 100%;
    margin-top: -180px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .box-image {
    width: 100%;
    margin-top: -180px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (min-width: 576px) and (max-width: 768px) {
  .box-image {
    width: 100%;
    margin-top: -150px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (max-width: 576px) {
  .box-image {
    width: 100%;
    margin-top: -130px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}
</style>
